import Grid from '@mui/material/Grid2';
import { GoogleAdsSettings } from './GoogleAdsSettings';
import { MetaPixelSettings } from './MetaPixelSettings';
import { TikTokPixelSettings } from './TikTokPixelSettings';

export const AnalyticsSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <MetaPixelSettings />
      </Grid>

      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <TikTokPixelSettings />
      </Grid>
      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <GoogleAdsSettings />
      </Grid>
    </Grid>
  );
};
